// extracted by mini-css-extract-plugin
export default {"attributesWrapper":"N7rwX","header":"tW4e2","title":"JlpRc","buttons":"xj4jk","search":"Wnvty","attributesList":"gSKYN","list":"YMS9m"};